import React from 'react';
import {ImageCompanyLogo} from '../Images';

class PublicCompanyLogo extends React.Component {
  static defaultProps = {
    className: 'mb-5 mx-auto',
    draggable: false,
  };

  render() {
    const {companyType, file, size, className, draggable} = this.props;

    return (
      <ImageCompanyLogo
        className={className}
        companyType={companyType}
        file={file}
        size={size}
        draggable={draggable}
      />
    );
  }
}

export default PublicCompanyLogo;
